(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ldmlnum", [], factory);
	else if(typeof exports === 'object')
		exports["ldmlnum"] = factory();
	else
		root["ldmlnum"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition